import { toast } from 'react-toastify';
import Service from '../../lib/Service';
import { testimonialActions } from '../ActionTypes';


export const fetchTestimonial = () => async (dispatch) => {
  try {
    dispatch({
      type: testimonialActions.TESTIMONIAL_FETCH_START
    });

    const resData = await Service.GET({
      name: 'testimonial',
      queryString: ''
    }).then((res) => {
      if (res.success) {
        return res.data;
      }
      throw new Error(res.message);
    });
    dispatch({
      type: testimonialActions.TESTIMONIAL_FETCH_SUCCESS,
      payload: resData
    });
  } catch (error) {
    dispatch({
      type: testimonialActions.TESTIMONIAL_FETCH_FAILED,
      payload: { error: error.message }
    });
  }
};
export const saveTestimonial = (formData) => async (dispatch) => {
  try {
    const payload = {
      ...formData
    };
    dispatch({
      type: testimonialActions.TESTIMONIAL_SAVE_START
    });
    await Service[formData.Id === '0' ? 'POST' : 'PUT']({
      name: 'testimonial',
      payload
    }).then((res) => {
      if (res.success) {
        return res.data;
      }
      throw new Error(toast.error(res.message));
    });
    dispatch({
      type: testimonialActions.TESTIMONIAL_SAVE_SUCCESS
    });
    toast.success('Saved Successfully');
    setTimeout(() => { window.location.href = '/testimonial'; }, 1000);
  } catch (error) {
    dispatch({
      type: testimonialActions.TESTIMONIAL_SAVE_FAILED,
      payload: { formError: error.message }
    });
  }
};

export const editTestimonial = (testimonialId) => async (dispatch, getState) => {
  try {
    const { testimonialList } = getState().testimonial;
    const data = testimonialList.find((item) => item.Id === testimonialId);
    if (!data) {
      throw new Error('Something went wrong');
    }
    dispatch({
      type: testimonialActions.TESTIMONIAL_SET_FORM,
      payload: { form: data }
    });
  } catch (error) {
    toast.error(error.message);
  }
};

export const resetForm = () => (dispatch) => dispatch({ type: testimonialActions.TESTIMONIAL_RESET_FORM });

export const deleteTestimonial = (Id) => async (dispatch) => Service.DELETE({
  name: 'testimonial',
  payload: { Id }
}).then((res) => {
  if (res.success) {
    dispatch(fetchTestimonial());
    return true;
  }
  throw new Error(res.message);
});
